import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getAuth } from "firebase/auth";

// Firebase FCM config
const firebaseConfig = {
  apiKey: "AIzaSyBXIAG11s5lqyDGf4sjRAd1NMxewCcJAy8",
  authDomain: "hhmapp-88b37.firebaseapp.com",
  databaseURL: "https://hhmapp-88b37.firebaseio.com",
  projectId: "hhmapp-88b37",
  storageBucket: "hhmapp-88b37.appspot.com",
  messagingSenderId: "400775567920",
  appId: "1:400775567920:web:548238a340754d4286abf5",
  measurementId: "G-P5HRZX9VCV"
};

// Intialize the firebase app
const firebaseApp = initializeApp(firebaseConfig);

export const messaging = getMessaging(firebaseApp);
export const _auth = getAuth(firebaseApp);